<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="requestFields"
      :page.sync="pagination.page"
      :items-per-page.sync="paginationReservationTemplateField.rowsPerPage"
      :loading="loading"
      loading-text=""
      :items-per-page-text="rowsPerPageText"
      :items-per-page-items="rowsPerPageItems"
      :header-props="{ sortIcon }"
      :footer-props="{ prevIcon, nextIcon, 'items-per-page-options':rowsPerPageItems}"
      @pagination="setRowsOnLocalStorage(dataTableReservationTemplateFieldId,paginationReservationTemplateField.rowsPerPage)"
      class="elevation-2 no-show-permission"
    >
      <template v-slot:item="props">
        <tr>
          <td>{{ props.item.request_form_field.label }}</td>

          <td>{{ props.item.artf_default_value }}</td>

          <td v-if="userCanEditOrRemoveItems">
            <app-datatable-action-buttons
              :user-can-edit="true"
              @edit="$emit('edit-item', props.index)"
              :user-can-delete="true"
              @delete="askConfirmationToDeleteItem(props.item)"
            />
          </td>
        </tr>
      </template>

      <template v-slot:pageText="props">
        {{ props.pageStart }} - {{ props.pageStop }} {{ $t("tables.Of") }}
        {{ props.itemsLength }}
      </template>

      <template v-slot:no-data>
        <div v-if="loading" />
      </template>
    </v-data-table>

    <app-dialog-box
      :open="deleteDialog"
      :title="$t('Delete')"
      :content="$t('DeleteConfirmation') + '?'"
      :main-action-label="$t('No')"
      @mainAction="cancelDelete"
      :secondary-action-label="$t('Yes')"
      @secondaryAction="confirmDelete"
    />
  </div>
</template>

<script>
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
import DataTableNoResults from "@/components/_Atoms/DataTableNoResults";
import AppDatatableActionButtons from "@/components/_Molecules/AppDatatableActionButtons";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";

export default {
  name: "AssetReservationManagementTemplateFieldsList",

  components: { AppDialogBox, AppDatatableActionButtons, DataTableNoResults },

  mixins: [managementDatatableMixin],

  props: {
    requestFields: {
      type: Array,
      required: true
    },

    actionType: String
  },

  data() {
    return {
      pagination: {
        sortBy: "request_form_field.order"
      },
      dataTableReservationTemplateFieldId: "dataTableReservationTemplateFieldId" ,
      paginationReservationTemplateField: {
        rowsPerPage: this.getRowsFromLocalStorage("dataTableReservationTemplateFieldId")
      },
    };
  },

  computed: {
    userCanEditOrRemoveItems() {
      return this.actionType !== "view";
    },

    mainHeaders() {
      return [
        {
          text: this.$i18n.tc("Field", 1),
          align: "left",
          value: "request_form_field.label"
        },
        { text: this.$i18n.t("DefaultValue"), value: "artf_default_value" }
      ];
    }
  },

  mounted() {
    this.loading = false;
  },

  methods: {
    askConfirmationToDeleteItem(item) {
      this.deleteDialog = true;
    },

    confirmDelete() {
      this.$emit("delete-item");
      this.deleteDialog = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AssetReservationManagement/Templates/ReservationTemplateFieldsList.vue